import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { deTranslations } from './i18n/de';
import { enTranslations } from './i18n/en';

const isBrowser = typeof window !== 'undefined';
let preselectedLang = 'de'; // default fallback

if (isBrowser) {
  const userAgent = navigator.userAgent.toLowerCase();
  const isBot = /bot|crawler|spider|crawling/i.test(userAgent);
  const isGSCInspection = /google-inspectiontool/.test(userAgent);
  const savedLang = localStorage.getItem('i18nextLng');
  const pathname = window.location.pathname;
  const isEnglishPath = pathname.startsWith('/en');
  if (isEnglishPath) {
    preselectedLang = 'en-GB'; // Always English for /en paths
    localStorage.setItem('i18nextLng', preselectedLang);
  } else if ((isBot || isGSCInspection) && !savedLang) {
    preselectedLang = 'de-CH'; // Force German for bots
    localStorage.setItem('i18nextLng', preselectedLang);
  }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false,
    fallbackLng: 'de',
    load: 'languageOnly',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    keySeparator: '.',
    detection: {
      order: ['localStorage', 'navigator'],
      checkWhitelist: true,
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    },
    resources: {
      de: {
        translation: deTranslations
      },
      en: {
        translation: enTranslations
      }
    }
  });

export default i18n;